import React from 'react';
import { Link } from 'react-router-dom';
import './HarperCollins.css';
import { useTranslation } from 'react-i18next';
import Banner from 'assets/img/banner-ielts.jpg';
import CourseIelts from 'components/Cards/courseIelts';
import GlobalStore from 'stores/globalStore';

const IELTS: React.FC = () => {
  const { bookData } = GlobalStore.useContainer();
  const { t } = useTranslation();

  return (
    <div className='harper-collins'>
      <h2 className="course__title">
        IETLS Speaking Test
      </h2>
      <p className="course__des">{t('courses.des_harper_collins')}</p>
      <img src={Banner} alt="banner" className="course__banner" />
      <div className="oxfords">
        {bookData.ielts.map((hpc, index) => (
          <div
            className="oxford__item"
            key={index}
          >
            <CourseIelts
              product={hpc}
            />
          </div>
        ))}
      </div>
      <div className="nav__mobile">
        <p className="nav__mobile__title">{t('courses.see_more_package')}:</p>
        <Link to="/course/elsa-oxford">
          <button className="nav__mobile__btn">ELSA Oxford Busniess Result</button>
        </Link>
        <Link to="/course/harper-collins">
          <button className="nav__mobile__btn">ELSA by Harper Collins</button>
        </Link>
      </div>
    </div>
  );
};

export default IELTS;
